import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import type { TFunction } from 'i18next';

interface Props {
	errorText?: string;
	ctaButton?: {
		onClick: () => void;
		variant?: 'text' | 'contained' | 'outlined';
		text?: string;
	};
	t: TFunction;
}

const ErrorState = (props: Props) => {
	const { t, ctaButton } = props;
	const errorText =
		props.errorText ??
		(!!ctaButton?.onClick ? t('common:errors.somethingWentWrong') : t('common:errors.error'));
	const errorCtaText = ctaButton?.text ?? t('common:actions.tryAgain');

	return (
		<Box textAlign="center">
			<Typography>{errorText}</Typography>
			{!!ctaButton?.onClick && (
				<Box my={2}>
					<Button
						variant={ctaButton.variant ?? 'contained'}
						color="primary"
						onClick={ctaButton.onClick}
					>
						{errorCtaText}
					</Button>
				</Box>
			)}
		</Box>
	);
};

export default ErrorState;
